import { Slider } from '@change/ds-forms';
import type { SliderProps } from '@change/ds-forms';

import { AmountInput } from './components/AmountInput';
import { ValidationErrorMessage } from './components/ValidationErrorMessage';
import { useSliderAmountSelector } from './hooks/useSliderAmountSelector';

type SliderAmountSelectorProps = {
	layout?: SliderProps['layout'];
};

export function SliderAmountSelector({ layout = 'labelsInline' }: SliderAmountSelectorProps): JSX.Element {
	const {
		data: {
			amount,
			ariaLabel,
			currencySymbol,
			placeholder,
			maxValue,
			minValue,
			sliderStep,
			errorMessage,
			sliderAmount,
		},
		actions: { formatValue, formatTooltipValue, onSliderChange, onSliderChangeEnd, onInputChange, onInputFocus },
	} = useSliderAmountSelector();

	return (
		<div className="mx-auto mt-2 w-full max-w-2xl">
			<div>
				<Slider
					data-qa="slider-amount-selector"
					ariaLabel={ariaLabel}
					layout={layout}
					showTooltip
					value={sliderAmount}
					onChange={onSliderChange}
					onChangeEnd={onSliderChangeEnd}
					minValue={minValue}
					maxValue={maxValue}
					step={sliderStep}
					formatValue={formatValue}
					formatTooltipValue={formatTooltipValue}
					name="amountSlider"
					tooltipAlignment="follow"
				/>
			</div>
			<div className="-mt-2">
				<AmountInput
					currencySymbol={currencySymbol}
					errorMessage={errorMessage}
					onChange={onInputChange}
					onFocus={onInputFocus}
					value={amount}
					placeholder={placeholder}
					height="56px"
				/>
			</div>
			<ValidationErrorMessage />
		</div>
	);
}
